import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ConceptosService } from '../../../services/conceptos.service';
import { ProveedoresService } from '../../../services/proveedores.service';
import { CuentasPorPagarService } from '../../../services/cuentas-por-pagar.service';

@Component({
  selector: 'app-modal-seleccion-cxp',
  templateUrl: './modal-seleccion-cxp.component.html',
  styleUrls: ['./modal-seleccion-cxp.component.scss']
})
export class ModalSeleccionCXPComponent implements OnInit {
    @Output() cxpSeleccionada: EventEmitter<any> = new EventEmitter;
    @Input() public obraSeleccionada: any;

    @ViewChild('content') private content: TemplateRef<any>;

    public loading: boolean = false;
    public modal: any = null;
    public cuentasPorPagar: any [] = [];

    //filters
    public fechaVencimientoPago: any;
    public obraSelected: any = { id_obra: 20};  
    public proveedorSelected: any = {};
    public conceptoSelected: any = {}; 

    //helpers
    public conceptos: any [] = [];
    public proveedores: any [] = [];
    public loading_conceptos: boolean = false;
    public loading_proveedores: boolean = false;

    constructor(private modalService: NgbModal, 
        private cuentasPorPagarService: CuentasPorPagarService,
        private conceptosService:ConceptosService,
        private proveedoresService: ProveedoresService) { }

    ngOnInit() {
        this.setupComponent();
    }

    private setupComponent(){
        this.loadCuentasPorPagar();
        this.loadConceptos();
        this.loadProveedores();
    }

    public openModal() {
        this.modal = this.modalService.open(this.content, { size: 'lg' });
    }

    public closeModal() {
        this.modal.close();
    }

    private loadCuentasPorPagar(){
        let filters = this.getFiltes();
        
        //Se requiere definir la fecha de vencimiento y el id de la obra
        if(!filters.fecha_pago_limite || !filters.id_obra){
            return;
        }

        this.loading = true;

        this.cuentasPorPagarService.listarCuentasPorPagar(filters)

        .subscribe(response => {
            this.cuentasPorPagar = response.json().content;
            this.loading = false;
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading = false;
        });
    }

    public seleccionarCuenta(cuentaPorPagar){
        this.cxpSeleccionada.emit(cuentaPorPagar);
        this.modal.close();       
    }

    private loadConceptos(){
        this.loading_conceptos = true;
        this.conceptosService.getAllConceptos()
        .subscribe(
          (response)=>{
            let content = response.json().content;
            this.conceptos = content;
            this.loading_conceptos = false;
          },
          (error)=>{
            this.loading_conceptos = false;
          }
        );
    }

    private loadProveedores(){
        this.loading_proveedores = true;
        this.proveedoresService.getProveedorestoSelect()
        .subscribe(response => {
            let content = response.json().content;
            this.proveedores = content.proveedores;
            this.loading_proveedores = false;
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_proveedores = false;
        });
    }

    /**
     * Utilities
     */

    private getFiltes(){        
        //Solo se muestran las cuentas por pagar que tienen los estatus AUTORIZADO|PARCIALMENTE_PAGADO
        let filters = {
            fecha_pago_limite: this.fechaVencimientoPago,
            id_obra: (this.obraSeleccionada && this.obraSeleccionada.obras.idObras) 
                ? this.obraSeleccionada.obras.idObras : null,
            id_proveedor: this.proveedorSelected.idProveedores 
                ? this.proveedorSelected.idProveedores : null,
            id_concepto: this.conceptoSelected.idConceptos 
                ? this.conceptoSelected.idConceptos : null,
            estatus: 'AUTORIZADO|PARCIALMENTE_PAGADO',
        }

        return filters;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/movimientos-obra/modal-seleccion-cxp/modal-seleccion-cxp.component.ts